import { withStyles } from '@material-ui/core/styles';
import { LinearProgress, Tooltip } from '@mui/material';
import { ProgressBar } from 'customer_portal-ui-shared';
import { AbsColor } from '../../constants';
import { useAppSelector } from '../../hooks';
import CalendarListItemDetails from './calendar-list-item-details.component';

interface CalendarListItemProps {
    index: number;
    classNumber: string;
    year: number;
}

interface RenderBarProps {
    index: number;
    itemCount: number | undefined;
    barColor: string;
}

const RenderBar = ({ index, itemCount, barColor }: RenderBarProps) => {
    const GetColor = () => {
        if (!itemCount || itemCount <= 0) {
            if (index % 2 === 0) return AbsColor.White1;
            return AbsColor.Gray1;
        }

        return barColor;
    };

    return <ProgressBar value={100} color={GetColor()} />;
};

const CalendarListItem = ({ index, classNumber, year }: CalendarListItemProps) => {
    const calendarItem = useAppSelector((state) => state.Calendar.List[`${classNumber}`]);
    const isLoading = useAppSelector((state) => state.Calendar.List[`${classNumber}`]?.IsLoading);

    const surveyGroup = calendarItem?.CalendarGroup?.find((f) => f.Year === year.toString());

    const toolTipStyle = {
        tooltip: {
            backgroundColor: 'transparent'
        }
    };

    const CustomTooltip = withStyles(toolTipStyle)(Tooltip);

    return (
        <>
            {isLoading ? (
                <LinearProgress />
            ) : (
                <CustomTooltip title={<CalendarListItemDetails year={year} classNumber={classNumber} />} placement="bottom" arrow>
                    <div>
                        <RenderBar itemCount={surveyGroup?.HighRisk.length} barColor={AbsColor.HighRisk} index={index} />
                        <RenderBar itemCount={surveyGroup?.MediumRisk.length} barColor={AbsColor.MediumRisk} index={index} />
                        <RenderBar itemCount={surveyGroup?.LowRisk.length} barColor={AbsColor.LowRisk} index={index} />
                    </div>
                </CustomTooltip>
            )}
        </>
    );
};

export default CalendarListItem;
